import { GridFeatureManager, InstancePlugin } from "@bryntum/schedulerpro";
import { PLUGINS_KEYS } from "../../other/constants/PluginKeys.jsx";
import { TIMELINE_CONG_KEYS } from "../../other/constants/OtherKeys.jsx";
import SwivuCalendarHelper from "../../other/utils/calendarUtils.jsx";

const DEFAULTS = {
  [TIMELINE_CONG_KEYS.stripeNonWorkingDays]: true,
  [TIMELINE_CONG_KEYS.hideNonWorkingDays]: false,
  [TIMELINE_CONG_KEYS.skipNonWorkingDayDuringReplicating]: false,
  [TIMELINE_CONG_KEYS.enableRedundantTaskEvents]: false
}

let intervalStoreDestroyCb;

const hideNonWorkingDays = (schedulerInstance, isHideNonWorkingDays) => {
  if (isHideNonWorkingDays) {
    const calendar = schedulerInstance.project.calendarManagerStore.getById("weekends");
    schedulerInstance.timeAxis.clearFilters();
    schedulerInstance.timeAxis.filter((t) => calendar.isWorkingTime(t.startDate, t.endDate))
  } else {
    schedulerInstance.timeAxis.clearFilters();
  }
}

const stripeNonWorkingDays = (schedulerInstance, nonWorkingTimeChecks, isStripeNonWorkingDays) => {
  const nonWorkingSlots = schedulerInstance.project.nonWorkingTimeStore.query((r) => nonWorkingTimeChecks.includes(r.id));
  if (isStripeNonWorkingDays) {
    SwivuCalendarHelper.clearNonWorkingIntervals(schedulerInstance.project);
    SwivuCalendarHelper.addNonWorkingSlotsOnWeek(schedulerInstance.project, nonWorkingSlots);
  } else {
    SwivuCalendarHelper.clearNonWorkingIntervals(schedulerInstance.project);
  }
}

const applyChangesOnSchedule = (schedulerInstance, featureState, changes) => {

  if (changes) {

    if (changes[TIMELINE_CONG_KEYS.stripeNonWorkingDays] || (changes[TIMELINE_CONG_KEYS.nonWorkingTimeChecks] && featureState[TIMELINE_CONG_KEYS.stripeNonWorkingDays])) {
      stripeNonWorkingDays(schedulerInstance, featureState[TIMELINE_CONG_KEYS.nonWorkingTimeChecks], featureState[TIMELINE_CONG_KEYS.stripeNonWorkingDays])
    } else if (changes[TIMELINE_CONG_KEYS.hideNonWorkingDays] || (changes[TIMELINE_CONG_KEYS.nonWorkingTimeChecks] && featureState[TIMELINE_CONG_KEYS.hideNonWorkingDays])) {
      hideNonWorkingDays(schedulerInstance, featureState[TIMELINE_CONG_KEYS.hideNonWorkingDays]);
    }
  }
}

export default class SwivuTimelineConfiguratorPlugin extends InstancePlugin {
  static get $name() {
    return PLUGINS_KEYS.swivuTimelineConfigurator;
  }

  static get pluginConfig() {
    return {
      after: ["applyState"]
    };
  }

  setupCalendarInstance(schedulerInstance) {
    const project = schedulerInstance.project;
    SwivuCalendarHelper.createWeekendCalendar(project);

    if (project.hasCrudStore("timeRanges")) {
      project.removeCrudStore("timeRanges");
    }
    if (intervalStoreDestroyCb) {
      intervalStoreDestroyCb();
      intervalStoreDestroyCb = null;
    }
    intervalStoreDestroyCb = SwivuCalendarHelper.reconfigureOnChange(schedulerInstance);
  }

  applyState() {
    if (this.client.project) {
      this.setupCalendarInstance(this.client);
      const stateToApply = Object.entries(this.state).reduce((accum, [key, value]) => {
        return {...accum, [key]: { oldValue: null, newValue: value }};
      }, {});
      applyChangesOnSchedule(this.client, this.state, stateToApply);
    }
  }

  swivuGetDefaultNonWorkingTimeSetting() {
    const nonWorkingTimeStore = this.client.project?.nonWorkingTimeStore;
    if (nonWorkingTimeStore) {
      return nonWorkingTimeStore.query((n) => n.isDefault).map((n) => n.id);
    }
    return null;
  }

  get state() {
    return Object.entries(TIMELINE_CONG_KEYS).reduce((accum, [key, value]) => {
      if (value === TIMELINE_CONG_KEYS.nonWorkingTimeChecks) {
        return { ...accum, [key]: this[value] ?? this.swivuGetDefaultNonWorkingTimeSetting() };
      }
      return { ...accum, [key]: this[value] ?? DEFAULTS[value] };
    }, {});
  }

  get defaultState() {
    return Object.entries(TIMELINE_CONG_KEYS).reduce((accum, [key, value]) => {
      return { ...accum, [key]: value !== TIMELINE_CONG_KEYS.nonWorkingTimeChecks ? DEFAULTS[value] : this.swivuGetDefaultNonWorkingTimeSetting() };
    }, {});
  }

  swivuExecuteSettings(key, value, isStateChange = true) {
    const oldValue = this[key];
    this[key] = value;

    const changes =  { [key]: { oldValue, newValue: value } };

    applyChangesOnSchedule(this.client, this.state, changes);

    if (isStateChange) {
      this.trigger("timelineConfigUpdate", { changes });
      this.client.trigger('stateChange');
    }
  }

}

GridFeatureManager.registerFeature(SwivuTimelineConfiguratorPlugin, true, ['SchedulerPro']);
